module.exports = __webpack_public_path__ + "static/media/4S.3e78de89.svg";